import { fetchXsrf } from "@/lib/fetchHelpers.3";
import { mainStore } from "@/mainStore";
export async function deleteDraft(context: mainStore, id: string, asAdmin: boolean, areaCode: string) {
    const url = await context.getUrl("deleteDraft", { tenantCode: areaCode, formId: id, asAdmin: asAdmin });
    const response = await fetchXsrf(context, url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "same-origin",
    });
    if (response.status == 200 || isOfflineAndUsingServiceWorker(response)) {
        return;
    } else {
        throw new Error("Not 200 OK: " + response.status + " " + response.statusText);
    }
}
let hasServiceWorker = false;
if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready.then(function () {
        hasServiceWorker = true;
    });
}
export function isOfflineAndUsingServiceWorker(response: Response) {
    if ((navigator.onLine && response.statusText != "Service worker timeout") || !("serviceWorker" in navigator)) {
        return false;
    }
    return hasServiceWorker;
}
export function isUsingServiceWorker() {
    return hasServiceWorker;
}
